import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import resourceSubject from '../reactivity/resource-subject';

Component('tr-project-kanban-trigger', {
  ready() {
    console.debug('trigger project_kanban_view_show');
    $(() => {
      resourceSubject('user-guide').next('project_kanban_view_show', {});
    });
  },
  beforeCache() {
    this.remove();
  },
});
